import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceGSTN {
    lookupService = new APIServiceLookUp();

    async getGSTN(body) {
        var serviceType = "POST";
        var url = `${API_URL}gstn/getGSTN`;
        var token = '';
        var apiService = this.lookupService.getAPIService(serviceType);
        var response = await apiService.doCall(url, body, token);
        return response;
    }

    async setGSTN(body) {
        var serviceType = "POST";
        var url = `${API_URL}gstn/setGSTN`;
        var token = '';
        var apiService = this.lookupService.getAPIService(serviceType);
        var response = await apiService.doCall(url, body, token);
        return response;
    }

    async updateGSTN(body) {
        var serviceType = "POST";
        var url = `${API_URL}gstn/updateGSTN`;
        var token = '';
        var apiService = this.lookupService.getAPIService(serviceType);
        var response = await apiService.doCall(url, body, token);
        return response;
    }

}